import { useEffect, useRef } from 'react'
import { Box } from '@chakra-ui/react'
import Pagination from '@/components/Pagination'

import { useQueryParamsContext } from '@/lib/context/queryParams'

interface Props {
  currentPage: number
  totalPage: number
}

const queryKey = 'search'

function PageHeader({ currentPage, totalPage }: Props): React.ReactElement {
  const inputRef = useRef<HTMLInputElement>(null)

  const { query, setQuery } = useQueryParamsContext()

  useEffect(() => {
    if (inputRef.current && query[queryKey]) {
      inputRef.current.value = query[queryKey]
    }
  }, [inputRef.current])

  return (
    <Box
      layerStyle="container"
      sx={{ pt: 8, pb: 8, w: 'fit-content', m: 'auto' }}
    >
      {totalPage > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPage={totalPage}
          onChangePage={(page) => {
            setQuery('page', `${page}`)
          }}
        />
      )}
    </Box>
  )
}

export default PageHeader
